import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["appearsIn"];
import FormattedMessage from 'I18n/components/FormattedMessage';
import UsageTracker from '../../../utils/UsageTracker';
import { Button } from 'foundations-components/transitional/components/Button';
import { useMyPlaylistsParams } from '../../myPlaylists/myPlaylistsHooks';
import { useACNavigate } from 'academy-common-lib/hooks/useACNavigate';
import { getMyPlaylistsUrl } from '../../myPlaylists/myPlaylistsRouting';
import { Dropdown } from 'foundations-components/transitional/components/Dropdown';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import I18n from 'I18n';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MyPlaylistsDropdownFilter = _ref => {
  let {
      appearsIn
    } = _ref,
    dropdownProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const navigate = useACNavigate();
  const {
    tab: selectedTab
  } = useMyPlaylistsParams();
  const handleMyPlaylistsFilterChange = value => {
    UsageTracker.trackStandalone('Filter Interaction', {
      action: 'filter-selected',
      value,
      isDropdown: true,
      key: 'my-playlists-filter',
      appearsIn
    });
    navigate(getMyPlaylistsUrl({
      tab: value
    }));
  };
  return /*#__PURE__*/_jsx(Dropdown, Object.assign({
    alignItems: "center",
    buttonText: I18n.text(`learningCenter.topFilters.myPlaylistsType.${selectedTab}`)
  }, dropdownProps, {
    children: /*#__PURE__*/_jsxs(List, {
      children: [/*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Button, {
          onClick: () => handleMyPlaylistsFilterChange('all'),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.topFilters.myPlaylistsType.all"
          })
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Button, {
          onClick: () => handleMyPlaylistsFilterChange('assigned-to-me'),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.topFilters.myPlaylistsType.assigned-to-me"
          })
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Button, {
          onClick: () => handleMyPlaylistsFilterChange('created-by-me'),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.topFilters.myPlaylistsType.created-by-me"
          })
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Button, {
          onClick: () => handleMyPlaylistsFilterChange('saved'),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.topFilters.myPlaylistsType.saved"
          })
        })
      }), /*#__PURE__*/_jsx(ListItem, {
        children: /*#__PURE__*/_jsx(Button, {
          onClick: () => handleMyPlaylistsFilterChange('archived'),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "learningCenter.topFilters.myPlaylistsType.archived"
          })
        })
      })]
    })
  }));
};